import React, { useContext } from "react";
import { dataContext } from "../../context/DataContextProvider";
import "./Header.css";
import "./ResponsiveHeader.css"
import { HashLink } from "react-router-hash-link";

const Header = () => {
  // when scroll header at top
  window.addEventListener("scroll", function () {
    const header = this.document.querySelector(".header");
    header?.classList.toggle("active", this.window.scrollY > 80);
  });
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "headerLogo"
  );

  const filetrKeyHeaderLogo = (key) => {
    if (filterAllWebParts) {
      const result = JSON.parse(filterAllWebParts[0]?.specification)?.filter(
        (item) => {
          return item.Key === key;
        }
      );
      return result;
    }
  };

  return (
    <header className="header d-flex">
      <div className=" d-flex content">
        <div className="logo-container">
          <img className="logo" src={filetrKeyHeaderLogo("logo")?.map(
                  (item) => item.Value
                )} alt="logo" />
        </div>
        <ul className="header-items">
          <li>
            <HashLink smooth to="/#about">درباره ما</HashLink>
          </li>
          <li>
            <HashLink smooth to="/#ingredients">ترکیبات</HashLink>
          </li>
          <li>
            <HashLink smooth to="/#blog">مقالات</HashLink>
          </li>
          <li>
            <HashLink smooth to="/#contactUs">ارتباط با ما</HashLink>
          </li>
          <li>
            <a href={window.Configs["en-url"]}>EN</a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
